export const DeletePopupModal = (props) => {

    const {
        cancelBtnCallBack,
        confirmBtnCallBack,
        deleteRecord,
        message = "Are you sure you want to delete this record?",
        heading = "Delete Record",
        loader = false,
    } = props;

    return (
        <div className="seminar-backdrop">
            <div className="modal-dialog modal-dialog-centered seminar-dialog delete-dialog" role="dialog" aria-modal="true" aria-labelledby="delete-popup-title">
                <div className="modal-content seminar-content">
                    <div className="d-flex align-items-center justify-content-between seminar-header">
                        <h6 className="m-0 fw-bold" id="delete-popup-title">{heading}</h6>
                        <button type="button" className="btn-close btn-close-white seminar-close" onClick={cancelBtnCallBack} aria-label="Close" />
                    </div>
                    <div className="seminar-body text-center delete-body">
                        <p>{message}</p>
                    </div>
                    <div className="d-flex justify-content-end gap-2 seminar-footer">
                        <button type="button" className="btn btn-outline-secondary seminar-btn-cancel" onClick={cancelBtnCallBack} disabled={loader}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-danger seminar-btn-primary delete-btn" onClick={() => confirmBtnCallBack(deleteRecord)} disabled={loader}>
                            {loader ? "Deleting..." : "Delete"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
